import { ConfigType } from './../types/config-type';

import { TActConf, TConfigItem } from '@/types/api-type';
import { request, url } from '@tencent/ppd-base-libs';

const APP_ID = 'wxcdaffda0606152a0';
// [
//   {
//     "confId": "test",
//     "title": "test标题",
//     "topImg": "https://test",
//     "bgColor": "#test",
//     "btnTop": "782",
//     "btnText": "立即查看",
//     "btnColor": "#FFFFFF",
//     "actUrl": "https://tests",
//     "confType": "material"
//   }
// ]
export async function getActConfig(confType: ConfigType): Promise<TActConf> {
  const config = await request.loadConfig(`//st.moneydata.hk/wuji/config/thirdAppRedirectCfg/thirdAppRedirect-${confType}.json?noreport=1`);

  return formatBusiConf(config || []);
}

/**
 * 生成用户标识
 */
function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-mixed-operators
    const r = Math.random() * 16 | 0; const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * 获取用户标识
 */
function getUserMark() {
  if (url.getUrlParam('clearUserMark') === '1') {
    // 用于测试
    localStorage.setItem('userMark', '');
  }
  // 后端控制缓存有效期30天
  let userMark = localStorage.getItem('userMark');
  if (!userMark) {
    const guidStr = guid();
    userMark = encodeURIComponent(guidStr);
    localStorage.setItem('userMark', userMark);
  }
  return userMark;
}

/**
 * 动态获取用户跳转的urlSchema
 * @param query base64的真实链接
 */
export async function getUserUrlSchema(actUrl: string): Promise<string> {
  const userMark = getUserMark();
  const retData = await request.get('/app/usershare/prom_get_usershare_url_scheme.cgi', {
    params: {
      user_id: userMark,
      query: window.btoa(actUrl),
      app_id: APP_ID,
    },
  });
  return retData.url_scheme;
}

/**
 * 动态获取用户跳转的urlSchema新版本，支持跳转到微信小程序
 * 202309更新，后端支持传第三方小程序信息跳转到小程序，
 * 但是为了兼容以前老的活动，参数上做了一个分支判断，当传入了path的情况下走新逻辑，没有的情况下走老逻辑，
 * 所以，如果是需要使用老的跳转逻辑，可以使用上面的getUserUrlSchema，但是为了统一用法，建议使用下面的函数，老的逻辑可以写为：
 * getWxUrlSchema({
 *   appId: APP_ID,
 *   path: '/pages/busigift/index',
 *   query: 'url=' + btoa(redirectUrl),
 * })
 * @param params
 * @returns
 */
export async function getWxUrlSchema(params: {
  /** 微信小程序appid */
  appId: string;
  /** 微信小程序页面path */
  path: string;
  /** 微信小程序页面参数，a=1&b=2字符串形式 */
  query?: string;
}): Promise<string> {
  const { appId, path, query } = params;
  const userMark = getUserMark();
  const retData = await request.get('/app/usershare/prom_get_usershare_url_scheme.cgi', {
    params: {
      user_id: userMark,
      query,
      path,
      app_id: appId,
    },
  });
  return retData.url_scheme;
}

function formatBusiConf(busiConf): TConfigItem[] {
  const arr: TConfigItem[] = [];

  busiConf.forEach((item) => {
    const {
      confId,
      title,
      topImg,
      bgColor,
      btnTop,
      btnColor,
      btnText,
      actUrl,
      wxAppId,
      wxAppPath,
      wxAppQuery,
    } = item;

    arr.push({
      confId,
      title,
      topImg,
      bgColor,
      btnTop: parseFloat(btnTop || 0),
      btnText,
      btnColor,
      actUrl,
      wxAppId,
      wxAppPath,
      wxAppQuery,
    });
  });

  return arr;
}
